type VisibilityState = Record<string, boolean>;

/** The one table column the PDF prints as two, rendered as a single `3/5` cell. */
const MULTI_COLUMN_EXPORT_IDS: Record<string, readonly string[]> = {
  steps: ['completed_steps', 'total_steps'],
};

/**
 * Resolves the export column ids for the columns currently visible in the table,
 * in table order.
 */
export const resolveExportColumns = (orderedColumnIds: readonly string[], visibility: VisibilityState): string[] =>
  orderedColumnIds.filter((id) => visibility[id] !== false).flatMap((id) => MULTI_COLUMN_EXPORT_IDS[id] ?? [id]);
